
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [523974, 797762, 953388, 692437, 632701, 624305, 25665] }, uniqueName: "canvas-lms" };
__webpack_require__.I = __webpack_require__.I || function() { throw new Error("should have __webpack_require__.I") }
